var GenericProductHandler = (function() {
    var cachedDOM = {};

    function handleSimpleAnalisysResponse(response) {
        var productMiniResultUrl =
            this.miniResultUrl + response.code_generatedProduct;

        GenericProductHandler.clearUserProductListCache(this.id, function() {
            window.location.href = productMiniResultUrl;
        });
    }

    function handleSimpleAnalisysError(error) {
        alert("Ocorreu um erro inesperado, tente novamente.");
        PsrProfileSelectorModal.closeAll();
    }

    function handleCompleteAnalisysResponse(response) {
        var productCompleteResultUrl =
            this.completeResultUrl + response.code_generatedProduct;

        GenericProductHandler.clearUserProductListCache(this.id, function() {
            window.location.href = productCompleteResultUrl;
        });
    }

    function handleCompleteAnalisysError(error) {
        alert("Ocorreu um erro inesperado, tente novamente.");
        PsrProfileSelectorModal.closeAll();
    }

    return {
        generate: function() {
            var siteID = cachedDOM.$siteID.val();
            var productName = cachedDOM.$productName.val();
            var productConfig = ProductListConfig.getProductList()[productName];
            var modalSteps = productConfig.modalSteps;
            var formValues = GenericProductHandler.getFormValueFromModals(
                modalSteps
            );
            var isProfileNotSelected =
                formValues.productStatus == PRODUCT_STATUS.PROFILE_NOT_SELECTED;
            var isProductComplete =
                formValues.productType == PRODUCT_TYPE.COMPLETE;

            if (isProfileNotSelected && isProductComplete) {
                return GenericProductHandler.createCompleteAnalisys(
                    productConfig,
                    formValues,
                    siteID
                );
            }

            return GenericProductHandler.createSimpleAnalisys(
                productConfig,
                formValues,
                siteID
            );
        },

        createSimpleAnalisys: function(productConfig, profileData, siteID) {
            $.ajax({
                type: "POST",
                url: productConfig.miniEndpoint,
                data: productConfig.buildMiniAjaxParams(profileData, siteID),
                dataType: "json"
            })
                .done(handleSimpleAnalisysResponse.bind(productConfig))
                .fail(handleSimpleAnalisysError);
        },

        createCompleteAnalisys: function(productConfig, profileData, siteID) {
            $.ajax({
                type: "POST",
                url: productConfig.completeEndpoint,
                data: productConfig.buildCompleteAjaxParams(
                    profileData,
                    siteID
                ),
                dataType: "json"
            })
                .done(handleCompleteAnalisysResponse.bind(productConfig))
                .fail(handleCompleteAnalisysError);
        },

        clearUserProductListCache: function(productId, callBack) {
            $.ajax({
                type: "POST",
                url: "/apiV1/cache/user-product-list/clear",
                data: {
                    product_id: productId
                },
                dataType: "json"
            }).done(callBack);
        },

        getCurrentProductConfig: function() {
            var productName = cachedDOM.$productName.val();
            var productList = ProductListConfig.getProductList();

            return productList[productName];
        },

        getFormValueFromModals: function(modalSteps) {
            var formsValues = modalSteps.map(function(stepModalName) {
                var $modal = $("[data-name='" + stepModalName + "'] form");
                var serializedForm = PsrProfileSelectorForm.serializeForm(
                    $modal[0]
                );

                return serializedForm;
            });

            var mergedFormsValues = formsValues.reduce(function(
                result,
                currentObject
            ) {
                for (var key in currentObject) {
                    if (currentObject.hasOwnProperty(key)) {
                        result[key] = currentObject[key];
                    }
                }

                return result;
            },
            {});

            return mergedFormsValues;
        },

        getCurrentProductSteps: function() {
            var currentProductConfig = GenericProductHandler.getCurrentProductConfig();

            return currentProductConfig.modalSteps;
        },

        init: function() {
            cachedDOM.$productName = $("[name='productName']");
            cachedDOM.$siteID = $("[name='siteID']");
        }
    };
})();
